const routes = [
  {
    path: '/reports',
    redirect: '/embedded/vsight/reports',
  },
];

export default routes;
